
<script>
import baseList from '@/views/components/base/baseHospital.vue'
export default {
  extends: baseList,

  data() {
    return {
      fy: true,
      hospitaltype: '商品列表',
      table: {
        mname: "commodity",
        key: "id",
        url: {
          list: "/admin/commodity/list",
          selectLike: '/admin/commodity/selectLike?commodityName=',
          addShop: 'admin/shopping/add'
        },
        output: false,
        order: 'id',
        qrCode: "qrCode",
      },
      tableCols: [],
      num: 0,
      tabList:[],
      commodity: [
        {
          title: "商品名称",
          key: "commodityName",
        },
        {
          title: "商品图片",
          key: "commodityImage",
          viewimage: true,

        },
        {
          title: "商品分类",
          key: "commodityType",
          minWidth: 160,
          align: "center",
        },
        {
          title: "标签",
          key: "labelName",
        },
      ],
      filters: [
      {
          label: "商品分类",
          name: "commodityTypeId",
          value: "",
          type: "select",
          dropList: [],
        },
        { label: '', name: 'search', value: '', type: 'input' },
      ],
      menus: [
      ],
    }
  },
  async created(){

    try{
        let res = await $utils.api.load(`/admin/commodityType/list`)
        if (res.status) {
          this.tabList = res.rows.slice(0,8)
        }
      }catch(e){
        console.log(e);
      }
  },
  methods:{

  }
}

</script>